export default __webpack_public_path__ + "static/media/HARYANA-4.6ba666be.webp";